import React, { useState, useEffect, useRef } from 'react';

const Settings = () => {
    const [settings, setSettings] = useState({
        max_vozila_dnevno: '4', cena_dnevnice: '8000', max_pokusaja: '1000', max_radnika_ukupno: '15',
        min_tim_kamion: '2', max_tim_kamion: '3', min_tim_pikap: '1', max_tim_pikap: '2',
        ideal_tim_kamion: '4', ideal_tim_pikap: '2',
        min_trajanje: '3', max_trajanje: '5', min_pauza: '0', radna_subota: 'false',
        max_kamiona: '2', max_pikapa: '2', praznici: ''
    });
    const [status, setStatus] = useState('');
    const dateInputRef = useRef(null);

    useEffect(() => {
        fetch('https://ecopell.ledscreen.rs/api/get-settings/')
            .then(res => res.json())
            .then(data => setSettings(prev => ({ ...prev, ...data })))
            .catch(err => setStatus('Greška pri učitavanju.'));
    }, []);

    const handleSave = () => {
        setStatus('Snimanje...');
        fetch('https://ecopell.ledscreen.rs/api/update-settings/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(settings)
        })
        .then(res => res.json())
        .then(data => {
            if(data.status === "success") {
                setStatus('Uspešno sačuvano!');
                setTimeout(() => setStatus(''), 3000);
            }
        });
    };

    const addDate = (e) => {
        const newDate = e.target.value;
        if (!newDate) return;
        const currentDates = settings.praznici ? settings.praznici.split(',') : [];
        if (!currentDates.includes(newDate)) {
            const updated = [...currentDates, newDate].filter(d => d).sort().join(',');
            setSettings({...settings, praznici: updated});
        }
        e.target.value = ''; // Resetuj input nakon izbora
    };

    const removeDate = (dateToRemove) => {
        const updated = settings.praznici.split(',').filter(d => d !== dateToRemove).join(',');
        setSettings({...settings, praznici: updated});
    };

    const s = {
        container: { padding: '20px', color: 'white', maxWidth: '800px', backgroundColor: '#0a132b', borderRadius: '8px' },
        group: { marginBottom: '15px', padding: '15px', border: '1px solid #1a2a4a', borderRadius: '5px', backgroundColor: '#0d1b3e' },
        title: { color: '#00ff00', borderBottom: '1px solid #3366ff', marginBottom: '15px' },
        label: { display: 'block', marginBottom: '5px', color: '#3366ff', fontSize: '13px', fontWeight: 'bold' },
        input: { width: '100%', padding: '10px', backgroundColor: '#050a1a', border: '1px solid #1a2a4a', color: 'white', borderRadius: '4px', fontSize: '14px' },
        row: { display: 'flex', gap: '15px', marginBottom: '10px' },
        sub: { color: '#ffcc00', fontWeight: 'bold', display: 'block', marginBottom: '10px', fontSize: '15px' },
        dateTrigger: { 
            width: '100%', padding: '12px', backgroundColor: '#050a1a', border: '2px dashed #3366ff', 
            color: '#00ff00', borderRadius: '4px', textAlign: 'center', cursor: 'pointer', fontWeight: 'bold' 
        },
        tag: { 
            backgroundColor: '#1a2a4a', padding: '8px 12px', borderRadius: '4px', marginRight: '8px', 
            display: 'inline-flex', alignItems: 'center', marginTop: '8px', fontSize: '14px', border: '1px solid #3366ff' 
        }
    };

    return (
        <div style={s.container}>
            <h2 style={s.title}>Podešavanja Algoritma</h2>
            
            <div style={s.group}>
                <span style={s.sub}>OSNOVNI LIMITI & SISTEM</span>
                <div style={s.row}>
                    <div style={{flex: 1}}><label style={s.label}>Cena dnevnice</label><input type="number" value={settings.cena_dnevnice} onChange={e=>setSettings({...settings, cena_dnevnice: e.target.value})} style={s.input}/></div>
                    <div style={{flex: 1}}><label style={s.label}>Max radnika/dan</label><input type="number" value={settings.max_radnika_ukupno} onChange={e=>setSettings({...settings, max_radnika_ukupno: e.target.value})} style={s.input}/></div>
                    <div style={{flex: 1}}><label style={s.label}>Max pokušaja</label><input type="number" value={settings.max_pokusaja} onChange={e=>setSettings({...settings, max_pokusaja: e.target.value})} style={s.input}/></div>
                </div>

                <div style={s.row}>
                    <div style={{flex: 1}}>
                        <label style={s.label}>Radna subota</label>
                        <select value={settings.radna_subota} onChange={e=>setSettings({...settings, radna_subota: e.target.value})} style={s.input}>
                            <option value="false">NE (Pon-Pet)</option>
                            <option value="true">DA (Uključi subotu)</option>
                        </select>
                    </div>
                </div>

                <div style={{marginTop: '15px'}}>
                    <label style={s.label}>Praznici (Neradni dani)</label>
                    <div style={s.dateTrigger} onClick={() => dateInputRef.current.showPicker()}>
                        📅 KLIKNI OVDE ZA IZBOR DATUMA
                    </div>
                    <input 
                        type="date" 
                        ref={dateInputRef} 
                        onChange={addDate} 
                        style={{display: 'none'}} 
                    />
                    
                    <div style={{marginTop: '10px', display: 'flex', flexWrap: 'wrap'}}>
                        {settings.praznici && settings.praznici.split(',').filter(d => d).map(d => (
                            <div key={d} style={s.tag}>
                                {d.split('-').reverse().join('.')}
                                <span onClick={() => removeDate(d)} style={{marginLeft: '10px', cursor: 'pointer', color: '#ff4444', fontWeight: 'bold'}}>✕</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div style={s.row}>
                <div style={{...s.group, flex: 1}}>
                    <span style={s.sub}>KAMION (Truck)</span>
                    <div style={s.row}>
                        <div style={{flex: 1}}><label style={s.label}>Min ljudi</label><input type="number" value={settings.min_tim_kamion} onChange={e=>setSettings({...settings, min_tim_kamion: e.target.value})} style={s.input}/></div>
                        <div style={{flex: 1}}><label style={s.label}>Max ljudi</label><input type="number" value={settings.max_tim_kamion} onChange={e=>setSettings({...settings, max_tim_kamion: e.target.value})} style={s.input}/></div>
                    </div>
                    <div style={{marginTop: '10px'}}>
                        <label style={s.label}>IDEALAN TIM</label>
                        <input type="number" value={settings.ideal_tim_kamion} onChange={e=>setSettings({...settings, ideal_tim_kamion: e.target.value})} style={{...s.input, borderColor: '#00ff00'}}/>
                    </div>
                </div>
                <div style={{...s.group, flex: 1}}>
                    <span style={s.sub}>PIKAP (Pickup)</span>
                    <div style={s.row}>
                        <div style={{flex: 1}}><label style={s.label}>Min ljudi</label><input type="number" value={settings.min_tim_pikap} onChange={e=>setSettings({...settings, min_tim_pikap: e.target.value})} style={s.input}/></div>
                        <div style={{flex: 1}}><label style={s.label}>Max ljudi</label><input type="number" value={settings.max_tim_pikap} onChange={e=>setSettings({...settings, max_tim_pikap: e.target.value})} style={s.input}/></div>
                    </div>
                    <div style={{marginTop: '10px'}}>
                        <label style={s.label}>IDEALAN TIM</label>
                        <input type="number" value={settings.ideal_tim_pikap} onChange={e=>setSettings({...settings, ideal_tim_pikap: e.target.value})} style={{...s.input, borderColor: '#00ff00'}}/>
                    </div>
                </div>
            </div>

            <div style={s.group}>
                <span style={s.sub}>VOZILA & TRAJANJE</span>
                <div style={s.row}>
                    <div style={{flex: 1}}><label style={s.label}>Max Kamiona</label><input type="number" value={settings.max_kamiona} onChange={e=>setSettings({...settings, max_kamiona: e.target.value})} style={s.input}/></div>
                    <div style={{flex: 1}}><label style={s.label}>Max Pikapa</label><input type="number" value={settings.max_pikapa} onChange={e=>setSettings({...settings, max_pikapa: e.target.value})} style={s.input}/></div>
                    <div style={{flex: 1}}><label style={s.label}>Ukupan limit</label><input type="number" value={settings.max_vozila_dnevno} onChange={e=>setSettings({...settings, max_vozila_dnevno: e.target.value})} style={s.input}/></div>
                </div>
                <div style={s.row}>
                    <div style={{flex: 1}}><label style={s.label}>Min dana</label><input type="number" value={settings.min_trajanje} onChange={e=>setSettings({...settings, min_trajanje: e.target.value})} style={s.input}/></div>
                    <div style={{flex: 1}}><label style={s.label}>Max dana</label><input type="number" value={settings.max_trajanje} onChange={e=>setSettings({...settings, max_trajanje: e.target.value})} style={s.input}/></div>
                    <div style={{flex: 1}}><label style={s.label}>Pauza</label><input type="number" value={settings.min_pauza} onChange={e=>setSettings({...settings, min_pauza: e.target.value})} style={s.input}/></div>
                </div>
            </div>

            <button onClick={handleSave} style={{width:'100%', padding:'15px', backgroundColor:'#28a745', color:'white', border:'none', cursor:'pointer', fontWeight:'bold', fontSize:'16px'}}>SAČUVAJ PODEŠAVANJA</button>
            {status && <div style={{marginTop:'15px', color:'#ffcc00', textAlign:'center', fontWeight:'bold'}}>{status}</div>}
        </div>
    );
};

export default Settings;